import createFailure from './create/failure';
import createRequest from './create/request';
import createSuccess from './create/success';
import deleteFailure from './delete/failure';
import deleteRequest from './delete/request';
import deleteSuccess from './delete/success';
import editFailure from './edit/failure';
import editRequest from './edit/request';
import editSuccess from './edit/success';
import getAllFailure from './getAll/failure';
import getAllRequest from './getAll/request';
import getAllSuccessWithData from './getAll/successWithData';
import getAllSuccessWithoutData from './getAll/successWithoutData';

const reducers = {
  createFailure,
  createRequest,
  createSuccess,
  deleteFailure,
  deleteRequest,
  deleteSuccess,
  editFailure,
  editRequest,
  editSuccess,
  getAllFailure,
  getAllRequest,
  getAllSuccessWithData,
  getAllSuccessWithoutData,
};

export default reducers;
